module.exports = __webpack_public_path__ + "img/details-desktop-bg.b1146d92.jpg";